export default [
  { name: 'docs-apidocs', path: 'docs/api', component: () => import('./pages/ApiDocs.vue') }
]
